<template>
  <div class="view-index">
    <hero/>
    <div class="container">
      <div class="index-features flex justify-between">
        <feature>
        <template v-slot:icon>
          <icon-food/>
        </template>
        <template v-slot:text>
          Breakfast and dinner
        </template>
        </feature>
        <feature>
          <template v-slot:icon>
            <icon-car/>
          </template>
          <template v-slot:text>
            Secure parking
          </template>
        </feature>
        <feature>
          <template v-slot:icon>
            <icon-clothes/>
          </template>
          <template v-slot:text>
            Laundry service
          </template>
        </feature>
        <feature>
          <template v-slot:icon>
            <icon-tv/>
          </template>
          <template v-slot:text>
            Full DSTV
          </template>
        </feature>
        <feature>
          <template v-slot:icon>
            <icon-water/>
          </template>
          <template v-slot:text>
            En-suite bathroom
          </template>
        </feature>
        <feature>
          <template v-slot:icon>
            <icon-fire/>
          </template>
          <template v-slot:text>
            Braai
          </template>
        </feature>
      </div>
      <award class="index-award"/>
    </div>
  </div>
</template>

<script>
import Award from '@/components/ui/Award'
import Hero from '@/components/ui/Hero'
import Feature from '@/components/ui/Feature'

export default {
  name: 'Index',
  components: {
    Award,
    Hero,
    Feature
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/Index.vue